import { motion } from "framer-motion";

const BlogFilters = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="mb-6 sm:mb-8">
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => {
          const isActive = activeCategory === category;
          return (
            <motion.button
              key={category}
              onClick={() => onCategoryChange(category)}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className={`relative px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 border
                ${
                  isActive
                    ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white border-transparent shadow-md shadow-blue-500/20 dark:shadow-blue-500/10"
                    : "bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 hover:text-blue-600 dark:hover:text-blue-400"
                }
              `}
            >
              {category}
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default BlogFilters;
